import React from 'react';
import { Text, Link } from '@nerdwallet/currency';
import { Impression } from '@nerdwallet/analytics/react/impression';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SegmentImpression from '../../../segment-impression';
import useAnalytics from '~/client/lib/segment/useAnalytics';
import { HOMEPAGE_SEGMENT_INSTRUMENTATION } from '~/client/lib/analytics-constants';
import styles from './secondary-campaign-card.module.less';

const SecondaryCampaignCard = ({
  badge,
  subtitle,
  ctaButtonText,
  ctaLinkUrl,
  elementImpressionEntityName,
  elementImpressionSectionName,
  instrumentationKey,
  trkQueryParam,
}) => {
  const { trackSegmentTrackEvent } = useAnalytics();
  const handleCampaignLinkClick = () => {
    trackSegmentTrackEvent(
      'Element Interaction',
      HOMEPAGE_SEGMENT_INSTRUMENTATION.secondary_campaign_module[
        instrumentationKey
      ]
    );
  };

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={{
        entity_name:
          HOMEPAGE_SEGMENT_INSTRUMENTATION.secondary_campaign_module[
            instrumentationKey
          ].entity_name,
        location:
          HOMEPAGE_SEGMENT_INSTRUMENTATION.secondary_campaign_module[
            instrumentationKey
          ].location,
      }}
    >
      <Impression
        entityName={elementImpressionEntityName}
        payload={{ section_name: elementImpressionSectionName }}
      >
        <div className={styles.cardContainer}>
          <img
            alt={badge.alt}
            src={badge.url}
            height={badge.height}
            width={badge.width}
            className={badge.top ? styles.topBadge : ''}
          />
          <div
            className={classNames(styles.text, {
              [styles.withTopBadge]: badge.top,
            })}
          >
            <Text>{subtitle}</Text>
          </div>
          <Link
            href={`${ctaLinkUrl}?trk=${trkQueryParam}`}
            onClick={handleCampaignLinkClick}
            className={styles.link}
          >
            {ctaButtonText}
          </Link>
        </div>
      </Impression>
    </SegmentImpression>
  );
};

SecondaryCampaignCard.propTypes = {
  badge: PropTypes.object,
  subtitle: PropTypes.string,
  ctaButtonText: PropTypes.string,
  ctaLinkUrl: PropTypes.string,
  elementImpressionEntityName: PropTypes.string,
  elementImpressionSectionName: PropTypes.string,
  instrumentationKey: PropTypes.string,
  trkQueryParam: PropTypes.string,
};

export default SecondaryCampaignCard;
